<template>
  <LoginFormTitle v-show="getShow" class="enter-x" />
  <Form
    class="p-4 enter-x"
    :model="formData"
    :rules="getFormRules"
    ref="formRef"
    v-show="getShow"
    @keypress.enter="getCode"
  >
    <FormItem>
      <a-button
        class="!border-none !pl-0 flex flex-row items-center cursor-pointer"
        size="small"
        @click="setLoginState(LoginStateEnum.CHECK_ACCOUNT_BEFORE_LOGIN)"
      >
        <Icon icon="M-terminal-iconchevron-left|ali" size="18" />{{ t('sys.login.back') }}
      </a-button>
    </FormItem>
    <FormItem name="email" class="enter-x">
      <Input
        size="large"
        v-model:value="formData.email"
        :placeholder="t('sys.login.loginIdPlaceholder')"
        class="fix-auto-fill"
        @change="handleEmailBlur"
        :disabled="true"
      >
        <template #prefix>
          <SvgIcon name="user" size="18" />
        </template>
      </Input>
    </FormItem>
    <FormItem name="username" class="enter-x">
      <!-- select 组件好像没有前缀图标配置，使用绝对定位增加图标 -->
      <SvgIcon
        name="user"
        size="18"
        class="absolute z-2 top-1/2 left-3 transform -translate-y-1/2"
      />
      <Select
        size="large"
        class="username-select bg-[var(--component-bg-color)]"
        v-model:value="formData.username"
        :options="usernameOptions"
        prefix-icon="user"
      />
    </FormItem>
    <FormItem name="password" class="enter-x">
      <InputPassword
        size="large"
        visibilityToggle
        v-model:value="formData.password"
        :placeholder="t('sys.login.passwordPlaceholder')"
      >
        <template #prefix>
          <SvgIcon name="lock-on" size="18" />
        </template>
      </InputPassword>
    </FormItem>
    <Teleport to="body">
      <Verify
        ref="verifyRef"
        :captchaType="'blockPuzzle'"
        :imgSize="{ width: '326px', height: '195px' }"
        :barSize="{ width: '50px', height: '40px' }"
        :ajaxParams="{ businessType: 'tokens', businessKey: formData.email }"
        mode="pop"
        @success="handleLogin"
      />
    </Teleport>

    <FormItem class="enter-x">
      <Button type="primary" size="large" block @click="getCode" :loading="loading">
        {{ t('sys.login.loginButton') }}
      </Button>
      <!-- <Button size="large" class="mt-4 enter-x" block @click="handleRegister">
        {{ t('sys.login.registerButton') }}
      </Button> -->
    </FormItem>

    <FormItem :style="{ 'text-align': 'center' }">
      <!-- No logic, you need to deal with it yourself -->
      <a-button
        class="!border-none text-[var(--primary-color-2)] cursor-pointer"
        @click="toResetPasswordPage"
      >
        {{ t('sys.login.forgetPassword') }}
      </a-button>
    </FormItem>

    <!-- <ARow class="enter-x">
      <ACol :md="8" :xs="24">
        <Button block @click="setLoginState(LoginStateEnum.MOBILE)">
          {{ t('sys.login.mobileSignInFormTitle') }}
        </Button>
      </ACol>
      <ACol :md="6" :xs="24">
        <Button block @click="setLoginState(LoginStateEnum.REGISTER)">
          {{ t('sys.login.registerButton') }}
        </Button>
      </ACol>
    </ARow> -->

    <!-- Pi 声明 -->
    <PiConfirmModal @register="register" @ok="handleOk" :identificationCode="identificationCode" />
  </Form>
</template>
<script lang="ts" setup>
  import { reactive, ref, unref, computed, watch } from 'vue';

  import { Form, Input, Button, Select } from 'ant-design-vue';

  import { SvgIcon } from '/@/components/Icon';
  import { Icon } from '@mcex/components';
  import LoginFormTitle from './LoginFormTitle.vue';

  import { useI18n } from '@mcex/locale';
  import { useMessage } from '/@/hooks/web/useMessage';
  import { useUserStore } from '/@/store/modules/user';
  import {
    LoginStateEnum,
    useLoginState,
    useFormRules,
    useFormValid,
    useVisitLoginType,
    visitLoginTypeEnum,
    useForgetPassState,
  } from './useLogin';
  // import { useDesign } from '/@/hooks/web/useDesign';
  import { createLocalStorage } from '/@/utils/cache';
  import { useGlobSetting } from '/@/hooks/setting';
  import { GRANT_TYPEENUM } from '/@/api/sys/model/userModel';
  //import { onKeyStroke } from '@vueuse/core';
  import Verify from './Verifition/Verify.vue';
  import { RouteLocationNormalizedLoaded } from 'vue-router';
  import PiConfirmModal from './PiConfirmModal.vue';
  import { useModal } from '/@/components/Modal/src/hooks/useModal';
  const [register, { openModal, closeModal }] = useModal();
  const { forgetFormData } = useForgetPassState();
  const props = defineProps<{
    currentRoute: RouteLocationNormalizedLoaded;
  }>();
  const FormItem = Form.Item;
  const InputPassword = Input.Password;
  const { t } = useI18n();
  const { notification, createMessage } = useMessage();
  // const { prefixCls } = useDesign('login');
  const userStore = useUserStore();
  const { kcClientId } = useGlobSetting();

  const { getVisitLoginType } = useVisitLoginType();
  const { setLoginState, getLoginState } = useLoginState();
  const { getFormRules } = useFormRules();
  const ls = createLocalStorage();

  const formRef = ref();
  const loading = ref(false);
  const rememberMe = ref(false);
  const verifyRef = ref();
  const identificationCode = ref('');
  const formData = reactive({
    email: '',
    username: '', // loginId
    password: '',
  });

  const { validForm } = useFormValid(formRef);

  //onKeyStroke('Enter', handleLogin);

  const getShow = computed(() => unref(getLoginState) === LoginStateEnum.LOGIN);
  // 账号列表
  const usernameOptions = computed(() =>
    userStore.accounts.map((item) => ({ label: item, value: item })),
  );
  function toResetPasswordPage() {
    if (formData.email.includes('@')) {
      forgetFormData.email = formData.email;
    } else {
      forgetFormData.email = '';
    }
    setLoginState(LoginStateEnum.RESET_PASSWORD);
  }
  function handleEmailBlur() {
    const email = formData.email;
    if (!email) return;
    const password = ls.get(email);
    if (password) {
      formData.password = password;
      rememberMe.value = true;
    }
  }
  function getCode() {
    verifyRef.value.show();
  }
  async function handleLogin(params) {
    const captchaVerification: string = params.captchaVerification;
    const data = await validForm();
    if (!data) return;
    try {
      loading.value = true;
      const userInfo = await userStore.login({
        goHome: getVisitLoginType.value !== visitLoginTypeEnum.BY_MODAL,
        businessType: 'tokens',
        businessKey: formData.email,
        password: data.password,
        username: formData.username,
        captchaVerification,
        client_id: kcClientId || '',
        grant_type: GRANT_TYPEENUM.LOGIN,
        mode: 'none', //不要默认的错误提示
        currentRoute: props.currentRoute,
      });
      if (userInfo) {
        notification.success({
          message: t('sys.login.loginSuccessTitle'),
          description: `${t('sys.login.loginSuccessDesc')}: ${userInfo.fullName}`,
          duration: 3,
        });
        if (rememberMe.value) {
          // 以email为key保存密码到localStorage
          ls.set(data.email, data.password);
        }
        // 登录成功后，重置状态
        setLoginState(LoginStateEnum.CHECK_ACCOUNT_BEFORE_LOGIN);
      }
    } catch (error) {
      console.log('🚀 ~ file: LoginForm.vue:170 ~ handleLogin ~ error:', error.response);

      // 检测到您的邮箱地址关联多个会员，请使用登录ID进行登录
      if (error.code === 1101004035) {
        createMessage.info(error.msg);
        return;
      }

      const desc = error.response?.data.error_description as string;

      // 需要确认专业投资人声明  need confirm pi statement, identificationCode:
      const NEED_CONFIRM_PI_STATEMENT = 'need confirm pi statement, identificationCode:';
      if (desc && desc.includes(NEED_CONFIRM_PI_STATEMENT)) {
        identificationCode.value = desc.split('identificationCode:')[1];
        openModal();
        return;
      }

      // 需要重置密码
      if (desc === 'Account is not fully set up') {
        // 将用户选择的loginId保存到localStorage
        ls.set('loginId', formData.username);
        setLoginState(LoginStateEnum.FORCE_RESET_PASSWORD);
        // 重置密码提示语改为info
        createMessage.info(t(`sys.login.${desc}`));
        return;
      }
      let kcError = 'sys.login.' + desc;
      if (desc == undefined) {
        kcError = 'sys.api.errMsg502';
      }
      createMessage.error(t(kcError) || t('sys.api.networkExceptionMsg'));
    } finally {
      loading.value = false;
    }
  }
  const handleOk = () => {
    closeModal();
    getCode();
  };
  const initData = () => {
    // 获取用户在第一步时录入的邮箱或账户
    formData.email = userStore.usernameOrEmail;
    // 默认选中第一个账号
    formData.username = userStore.accounts[0] || '';
  };
  watch(
    () => getShow.value,
    (_bool) => {
      _bool && initData();
    },
  );
</script>
<style lang="less" scoped>
  @link-cls: ~'@{namespace}-login-link';
  .@{link-cls} {
    color: @other-link-color;
  }

  :deep(.ant-select) {
    &:hover {
      .ant-select-selector {
        border-color: #1db8a0 !important;
      }
    }

    .ant-select-selector {
      padding-left: 40px !important;
    }
  }
</style>
